document.addEventListener('DOMContentLoaded', function () {
    initVideoGrid();
});

function initVideoGrid() {
    const gridSection = document.querySelector('.custom-video-grid');
    if (!gridSection) return;

    // Video Playback Logic
    gridSection.addEventListener('click', function (e) {
        const playBtn = e.target.closest('.video-card__play');
        if (playBtn) {
            const card = playBtn.closest('.video-card');
            const media = card.querySelector('.video-card__media');
            const videoId = playBtn.dataset.videoId;
            const videoType = playBtn.dataset.videoType;
            const videoUrl = playBtn.dataset.videoUrl;

            if (videoUrl) {
                media.innerHTML = `
          <div class="video-card__player">
            <video src="${videoUrl}" autoplay controls playsinline></video>
          </div>
        `;
            } else if (videoId) {
                let embedUrl = '';
                if (videoType === 'youtube') {
                    embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
                } else if (videoType === 'vimeo') {
                    embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
                }

                if (embedUrl) {
                    media.innerHTML = `
            <div class="video-card__player">
              <iframe src="${embedUrl}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
          `;
                }
            }
        }

        // Ajax See More Logic
        const seeMoreBtn = e.target.closest('.btn-see-more');
        if (seeMoreBtn) {
            const sectionId = seeMoreBtn.dataset.sectionId;
            const currentPage = parseInt(seeMoreBtn.dataset.currentPage) || 1;
            const limit = parseInt(seeMoreBtn.dataset.limit) || 6;
            const nextPage = currentPage + 1;

            seeMoreBtn.textContent = 'Loading...';
            seeMoreBtn.disabled = true;

            fetch(`${window.location.pathname}?section_id=${sectionId}`)
                .then(response => response.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newItems = doc.querySelectorAll('.video-card');
                    const wrapper = document.querySelector('.custom-video-grid__wrapper');

                    if (newItems.length > 0) {
                        newItems.forEach(item => wrapper.appendChild(item));
                        seeMoreBtn.parentElement.style.display = 'none';
                    } else {
                        seeMoreBtn.parentElement.style.display = 'none';
                    }
                })
                .catch(error => {
                    console.error('Error loading more videos:', error);
                    seeMoreBtn.textContent = 'SEE MORE';
                    seeMoreBtn.disabled = false;
                });
        }
    });
}
